import { useSelector } from "react-redux";
import { Box, LinearProgress, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { Badge, Button, Callout, PageHeader } from "@components/ui_v2";
import { RootState } from "@store/store";

const OFERTA = { monto: 1000000, plazo: 18, tasaAnual: 35, comision: 2 };
const fmt = (n: number) => "$" + Math.round(n).toLocaleString("en-US");

const STEPS_DONE = ["Solicitud", "Empresa", "Personas relacionadas"];

export const ExpReview = () => {
  const company = useSelector((state: RootState) => state.register.company);
  const r = OFERTA.tasaAnual / 100 / 12;
  const pago = Math.round((OFERTA.monto * r) / (1 - Math.pow(1 + r, -OFERTA.plazo)));

  return (
    <Box>
      <PageHeader
        eyebrow="Expediente · Estado"
        title="Tu expediente está en revisión"
        subtitle="Estamos validando los documentos y la información que enviaste. Te avisaremos por correo y WhatsApp en cuanto haya novedades."
      />

      <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "background.paper", borderRadius: 2, p: 3 }}>
        <LinearProgress variant="determinate" value={100} sx={{ mb: 3, height: 8, borderRadius: 4 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {STEPS_DONE.map((label) => (
            <Box key={label} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <CheckCircle color="success" fontSize="small" />
              <Typography variant="body2" sx={{ flex: 1 }}>
                {label}
              </Typography>
              <Badge tone="ok">Completo</Badge>
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={{ mt: 2, p: 3, bgcolor: "primary.base", borderRadius: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Resumen de la solicitud · {company.legal_name || company.name || "Empresa"}
          </Typography>
          <Badge tone="ok">Pre-aprobado</Badge>
        </Box>
        <Typography variant="h3" fontFamily="Outfit" color="primary.dark">
          {fmt(OFERTA.monto)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Plazo {OFERTA.plazo} meses · Tasa anual {OFERTA.tasaAnual}% · Comisión {OFERTA.comision}% · Pago mensual estimado {fmt(pago)}
        </Typography>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Callout tone="neutral">
          El siguiente paso es la formalización y firma de tus contratos — disponible próximamente en esta v2.
        </Callout>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Button tone="primary" withArrow disabled>
          Ver resultado final
        </Button>
      </Box>
    </Box>
  );
};
